export enum SheduledJobEntityType {
    Module = 'module',
    Section = 'section',
    PasswordlessAccess = 'passwordlessAccess',
}
